import { render } from "./MbaFinanceHrm.vue?vue&type=template&id=167d3b9a"
import script from "./MbaFinanceHrm.vue?vue&type=script&lang=js"
export * from "./MbaFinanceHrm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__